module.exports = function() {
	return new Worker(__webpack_public_path__ + "18db11734a9699ed67a8.worker.js");
};


/*****************
 ** WEBPACK FOOTER
 ** ./scripts/workers/yaml.worker.js
 ** module id = 387
 ** module chunks = 0
 **/